import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatSort, MatPaginator, MatDialog, MatDialogConfig } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { CallLogService } from 'src/app/shared/services/calllog.service';
//import { NotificationService } from 'src/app/shared/services/notification.service';
import { CallDetailLogModel } from 'src/app/shared/models/calllog.model';
//import { CallLogDetailComponent } from '../calllog-detail/calllog-detail.component';
import { UserModel } from 'src/app/shared/models/user.model';
import { UserService } from 'src/app/shared/services/user.service';
import { ClientModel } from 'src/app/shared/models/client.model';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-calllog-list',
  templateUrl: './calllog-list.component.html',
  styleUrls: ['./calllog-list.component.css']
})
export class CallLogListComponent implements OnInit {

  users : UserModel [];
  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['status', 'createTime', 'clientName' , 'clientType',  'destination',  'phone', 'duration', 'note', 'ticketNo', 'loginName', 'actions'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
  //@Input() mode : boolean;
  @Input() client : ClientModel;
  @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();

  //dialogConfig = new MatDialogConfig();

  constructor(
    private userService : UserService,
    private service :CallLogService,
    private userservice : UserService,
    //private toastr : ToastrService,
    private router : Router,
    private gnotify : GlobalNotification
    //private dialog : MatDialog
    )
    {
      /*
      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "60%";*/
    }

  ngOnInit() {


    this.userservice.getUserList().subscribe(
      res=>{
        this.users = res as UserModel [];
        this.refreshList();
      },
      err=>{}
    );


  }

  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }

  getCustomerString(type)
  {
    return GlobalConstants.getCustomerString(type);
  }
  /*
  populateForm(item : CallLogModel){
    this.service.formData  = Object.assign({}, item);
  }*/

  onDelete(id)
  {
    console.log("onDelete : " + id);

    if(!confirm("Are you sure to delete this call log?")) return;

    this.service.deleteData(id).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "Call Log Delete");
        this.gnotify.showSnackBar('Call Log Delete', 'Submitted successfully', "warning");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

  refreshList()
  {
    if(this.client)
    {
      this.service.findDataByCustomer(this.client.clientId).subscribe(
        res => {
          let array = res as CallDetailLogModel[];
          let result = array.map(
            obj => {
              obj.createByUser = this.users.find(item => item.id === obj.createBy);
              return {...obj}
            }
          );

          this.thisData = new MatTableDataSource(array);
          this.thisData.sort = this.sort;
          this.thisData.paginator = this.paginator;

          console.log("refreshList : " + this.thisData.data.length);
          this.applyFilter();
         },
         err =>{
           console.log(err);
         }
      );

    }
    else{
      this.service.getDetailList().subscribe(
        res => {
          let array = res as CallDetailLogModel[];
          let result = array.map(
            obj => {
              obj.createByUser = this.users.find(item => item.id === obj.createBy);
              return {...obj}
            }
          );

          this.thisData = new MatTableDataSource(array);
          this.thisData.sort = this.sort;
          this.thisData.paginator = this.paginator;

          console.log("refreshList : " + this.thisData.data.length);
         },
         err =>{
           console.log(err);
         }
      );
    }

  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {
    if(this.searchKey != null)
    this.thisData.filter = this.searchKey.trim().toLowerCase();
  }
/*
  onCreate()
  {
    this.service.initializeFormGroup();
    this.dialogConfig.data = {
      result : false
    };
    let dialogRef = this.dialog.open(CallLogDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        this.refreshList();
      }
    });
  }
*/
  onEdit(row){

    this.router.navigateByUrl('/calllog-detail/' + row.callId);
/*

    this.service.populateForm(CallDetailLogModel.convertToCallModel(row));
    this.dialogConfig.data = {
      data : row,
      result : false
    };

    let dialogRef = this.dialog.open(CallLogDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        this.refreshList();
      }
    });
*/
  }
}
